import styled from 'styled-components';

export const FormContainer = styled.form`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`;

export const InputWrapper = styled.div`
    width: 100%;
    margin-bottom: 22px;
    padding-right: 0px;
    ${props => props.theme.mediaQueries.tablet} {
        width: 50%;
        padding-right: ${props => props.hasElementsToTheRight ? '20px' : '0px'};
    };

    display: ${props => props.isHidden ? 'none' : 'block'};
`;

export const InputWrapperHalf = styled(InputWrapper)`
    width: 50%;
    padding-right: ${props => props.hasElementsToTheRight ? '20px' : '0px'};
    ${props => props.theme.mediaQueries.tablet} {
        width: 25%;
    };
`;

export const InputWrapperSmall = styled(InputWrapper)`
    width: 30%;
    ${props => props.theme.mediaQueries.tablet} {
        width: 13%;
    };
`;

export const InputWrapperMatchSmall = styled(InputWrapper)`
    width: 70%;
    border-left: 1px solid ${props => props.theme.color.gray};
    ${props => props.theme.mediaQueries.tablet} {
        width: 37%;
    };
`;